<template>
    <div class="dwyc app-container">
        <div class="top">
            <el-radio-group v-model="radio" size="small" @change="changeBtn">
                <el-radio-button :label="1">按公司</el-radio-button>
                <el-radio-button :label="2">按招标方式</el-radio-button>
                <el-radio-button :label="3">按项目经理</el-radio-button>
            </el-radio-group>
            <!-- <el-row type="flex" align="middle" style="padding-top: 10px">
                <div style="margin-right: 20px">
                    <span style="font-size: 14px">统计周期：</span>
                    <el-date-picker v-model="value1" type="monthrange" value-format="yyyy-MM" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" />
                </div>
                <statistics-search :search-type="searchType" @statisticsClick="statistics" />
            </el-row> -->
             <el-row type="flex" align="middle" style="padding-top: 10px">
                <div style="margin-right: 20px">
                    <span style="font-size: 14px">统计周期：</span>
                    <el-date-picker
      v-model="year"
      type="year"
      placeholder="选择年"
>
    </el-date-picker>
                    <!-- <el-date-picker v-model="value1" type="monthrange" value-format="yyyy-MM" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" /> -->
                </div>
               <el-button type="primary" icon="el-icon-check" @click="statistics">
                搜索
               </el-button>
               <el-button type="primary" icon="el-icon-refresh-right" @click="reset">
                重置
               </el-button>
            </el-row>
        </div>
        <div class="view" style="height:470px;">
        <div class="view_top">
          <div class="view_top_son">

            <!-- <div v-else style="text-align:center;margin-top:50px;">
              <template v-if="!isLoad">
                <img src="images/w-imgs/nomessage.png"><br>
                <span style="font-size:15px;color:#dbdbdb">暂无数据</span>
              </template>
            </div> -->
            <bingtu />
          </div>
          <div class="view_top_son">
            <xiantu />
          </div>
        </div>
      </div>
        <div>
            <data-table ref="dataTable" :list-tb="listTb" :list-tb1="listTb1" :list-tb2="listTb2" :list-data="listData" :radio="radio" :follow-num-total="followNumTotal" :clue-num-total="clueNumTotal" :customer-num-total="customerNumTotal" :sell-num-total="sellNumTotal" :contract-num-total="contractNumTotal" :sell-money-total="sellMoneyTotal" :possible-money-total="possibleMoneyTotal" :clue-num-total1="clueNumTotal1" :customer-num-total1="customerNumTotal1" :sell-num-total1="sellNumTotal1" :contract-num-total1="contractNumTotal1" :show-summary="true" />
        </div>
    </div>
</template>

<script>
const moment = require('moment')
import bingtu from './components/bingtu'
import xiantu from './components/xiantu'
import dataTable from './components/ListTable'
export default {
    components: {
        dataTable, bingtu, xiantu
    },
    data() {
        return {
            loading: false,
            radio: 1,
            // 跟进记录
            followNumTotal: '', // 跟进次数
            clueNumTotal: '', // 跟进线索次数
            customerNumTotal: '', // 跟进客户次数
            sellNumTotal: '', // 跟进商机次数
            contractNumTotal: '', // 跟进合同次数
            followNum: [], // 跟进次数图表
            clueNum: [], // 跟进线索次数图表
            customerNum: [], // 跟进客户次数图表
            sellNum: [], // 跟进商机次数图表
            contractNum: [], // 跟进合同图表
            xAxis: [],
            listData: [],
            datevalue: '',
            datevalue_: '',
            startTime: '',
            endTime: '',
            searchType: [
                {
                    type: 'subOrg',
                    title: '所属部门'
                },
                {
                    type: 'orgStaff',
                    title: '销售负责人',
                    parentType: 'subOrg'
                }
            ],

            listTb: [
                {
                    prop: 'name',
                    width: '150px',
                    title: '公司名称',
                    sortable: true,
                    align: 'center'
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '1月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'oneCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'oneAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '2月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'twoCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'twoAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '3月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'threeCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'threeAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '4月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'fourCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'fourAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '5月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'fiveCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'fiveAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '6月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'sixCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'sixAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '7月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'sevenCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'sevenAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '8月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'eightCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'eightAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '9月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'nineCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'nineAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '10月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'tenCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'tenAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '11月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'elevenCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'elevenAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '12月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'twelveCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'twelveAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '招标总量',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'totalCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'totalAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                }

            ],
            // 销售预测
            value1: [], // 选择时间
            year: this.getCurrentYear(), // 年份
            sellMoneyTotal: '', // 预计销售金额
            possibleMoneyTotal: '', // 概率金额
            xAxis2: [], // X轴数据
            possibleMoney: [], // 预计销售金额图表
            sellNum1: [],
            sellMoney: [], // 概率金额图表

            listTb1: [
                {
                    prop: 'name',
                    width: '150px',
                    title: '招标名称',
                    sortable: true,
                    align: 'center'
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '1月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'oneCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'oneAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '2月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'twoCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'twoAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '3月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'threeCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'threeAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '4月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'fourCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'fourAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '5月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'fiveCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'fiveAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '6月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'sixCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'sixAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '7月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'sevenCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'sevenAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '8月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'eightCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'eightAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '9月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'nineCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'nineAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '10月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'tenCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'tenAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '11月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'elevenCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'elevenAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '12月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'twelveCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'twelveAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '招标总量',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'totalCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'totalAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                }

            ],
            listTb2: [
                {
                    prop: 'name',
                    width: '150px',
                    title: '项目经理',
                    sortable: true,
                    align: 'center'
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '1月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'oneCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'oneAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '2月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'twoCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'twoAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '3月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'threeCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'threeAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '4月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'fourCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'fourAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '5月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'fiveCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'fiveAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '6月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'sixCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'sixAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '7月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'sevenCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'sevenAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '8月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'eightCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'eightAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '9月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'nineCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'nineAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '10月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'tenCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'tenAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '11月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'elevenCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'elevenAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '12月',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'twelveCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'twelveAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                },
                {
                    prop: 'personName',
                    width: '100px',
                    title: '招标总量',
                    sortable: true,
                    align: 'center',
                    child: [{
                        prop: 'totalCount',
                        width: '100px',
                        title: '数量',
                        sortable: true,
                        align: 'center'
                    }, {
                        prop: 'totalAmount',
                        width: '120px',
                        title: '金额（元）',
                        sortable: true,
                        align: 'center'
                    }]
                }

            ],
            // 业务新增
            clueNumTotal1: '', // 线索数
            customerNumTotal1: '', // 客户数
            sellNumTotal1: '', // 商机数
            contractNumTotal1: '', // 合同数
            xAxis3: [],
            clueNumtu: [], // 线索数
            cutomerNumtu: [], // 客户数
            sellNumtu: [], // 商机数
            contractNumtu: [], // 合同数

            pieList: [],
            selectDept: '',
            selectDept1: '',
            selectXs: '',
            dept: [],
            xs: [],
            loginUser: this.$store.getters.loginUser,
            yUnit: { name: '', align: 'end', size: '12', position: 'end', lineColor: '#000' },
            yUnits: [],
            xTypeName: [],
            chartType: [{ type: 'bar', yAxisIndex: 0 }],
            title: ''
        }
    },
    created() {
        this.$bus.emit('showNavSearch', false) // 取消右上搜索按钮
        const year = new Date().getFullYear()
        const month = moment().format('MM')
        this.value1 = [year - 1 + '-' + month, year + '-' + month]
    },
    beforeDestroy() {
        this.$bus.emit('showNavSearch', true) // 还原右上搜索按钮
    },
    mounted() {
        this.selectDept1 = ''
        this.$nextTick(() => {
            this.statistics()
        })
    },
    methods: {
        tooltipFormat(params) {
            if (params.length > 0) {
                var val = params[0].name + '<br>'
                params.map((item, index) => {
                    val += item.marker + item.seriesName + '：' + item.value + '<br>'
                })
            }
            return val
        },
        statistics(val) {
            this.$bus.emit('searchFn', this.year, this.radio)
            this.getData(val)
        },
        getCurrentYear() {
            const now = new Date()
            const year = now.getFullYear()
            return `${year}-01-01 00:00:00`
        },
        // tab切换
        changeBtn(val) {
            this.statistics(val)
        },
        // 重置
        reset() {
            this.value1[0] = this.$moment(new Date()).format('YYYY-MM')
            this.year = this.getCurrentYear()
            this.statistics()
        },
        getData(val) {
            let _this = this
            this.loading = true
            const endDay = new Date(this.value1[1].split('-')[0], this.value1[1].split('-')[1], 0).getDate()
            const data = {
                startTime: this.value1[0] + '-01 00:00:00',
                endTime: this.value1[1] + `-${endDay} 23:59:59`,
                salesDeptId: this.selectDept,
                personId: this.selectDept1
            }
            // 跟进记录
            if (this.radio === 1) {
                this.$http({
                    url: '/zbgl/zbxmlx/barChartAndList',
                    method: 'GET',
                    contentType: 'application/x-www-form-urlencoded',
                    params: {
                        year: this.year
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        _this.listData = res.body.listdata
                    }
                    _this.loading = false
                })
            }
            if (this.radio === 2) {
                this.$http({
                    url: '/zbgl/zbxmlx/barChartAndListWithType',
                    method: 'GET',
                    contentType: 'application/x-www-form-urlencoded',
                    params: {
                        year: this.year
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        _this.listData = res.body.listdata
                    }
                    _this.loading = false
                })
            }
            if (this.radio === 3) {
                this.$http({
                    url: '/zbgl/zbxmlx/barChartAndListByZbfzr',
                    method: 'GET',
                    contentType: 'application/x-www-form-urlencoded',
                    params: {
                        year: this.year
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        _this.listData = res.body.listdata
                    }
                    _this.loading = false
                })
            }
        }

    }
}
</script>

<style scoped lang="scss">
.dwyc {
    .top {
        display: flex;
        flex-direction: column;
    }
    .echart {
        height: 300px;
        margin-bottom: 20px;
    }
    .label {
        line-height: 36px;
        font-size: 14px;
        width: 84px;
        color: #606266;
        margin-left: 20px;
    }
}
/deep/.el-range-separator {
    width: 10% !important;
}

.top {
        display: flex;
        justify-content: left;
        margin-bottom: 20px;
    }
.view_top {
        height: 400px;
        display: flex;
    }
    .view_top_son {
            width: 50%;
    }
</style>
